import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ICreateProjectModal {
  presetRoomTypeId?: string | number;
}

export interface ICreateProjectModalContext {
  open: (state: ICreateProjectModal) => void;
}

/* istanbul ignore next */
const CreateProjectModalContext = React.createContext<ICreateProjectModalContext>({
  open: () => null,
});

export default CreateProjectModalContext;
